import type { TEntityFieldGroupType } from '../EntityFieldGroup';

export const getEntityGroupValueDestination = (type: TEntityFieldGroupType) => {
  const destinationsMap: Record<TEntityFieldGroupType, string> = {
    director: 'entity.data.additionalInfo.directors',
    ubo: 'entity.data.additionalInfo.ubos',
    trustee: 'entity.data.additionalInfo.trustees',
    member: 'entity.data.additionalInfo.members',
    partner: 'entity.data.additionalInfo.partners',
  };

  const valueDestination = destinationsMap[type];

  if (!valueDestination) {
    throw new Error(
      `Invalid entity group type: ${type}. Valid types are: ${Object.keys(destinationsMap).join(', ')}`,
    );
  }

  return valueDestination;
};
